import { useEffect } from "react";
import { Create, Datagrid, EditButton, List, SimpleForm, TextField, TextInput, useDataProvider, useNotify } from "react-admin";
import { MyDateField } from "../MyDateField";

const CategoryTopLevelEditButton = (props) => {
  if (!props.record.categories || props.record.categories.length == 0) {
    return <EditButton basePath="/categories" record={{ id: props.record.id }} />;
  }

  return <></>;
};

export const CategoriesList = (props) => (
  <List {...props} sort={{ field: "order", order: "ASC" }} exporter={false} pagination={false} bulkActionButtons={false}>
    <Datagrid isRowExpandable={(row) => row.categories} expand={<PostPanel />}>
      <TextField label="Genre/Category Name in TC" source="name_tc" sortable={false} />
      <TextField label="Genre/Category Name in EN" source="name_en" sortable={false} />
      <MyDateField label="onshelf DateTime" source="start_time" showTime sortable={false} />
      <MyDateField label="offshelf DateTime" source="end_time" showTime sortable={false} />
      <CategoryTopLevelEditButton />
    </Datagrid>
  </List>
);

export const CategoriesEdit = (props) => {
  const dataProvider = useDataProvider();

  useEffect(() => {
    dataProvider
      .getMpmPageByCategoryId(props.id)
      .then(({ data }) => {
        window.location.href = "/admin/#/mpm-pages/" + data.id;
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return <></>;
};

const redirect = () => "/categories";

export const CategoriesCreate = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };
  return (
    <Create {...props} onFailure={onFailure}>
      <SimpleForm redirect={redirect}>
        <TextInput source="name_tc" />
        <TextInput source="name_en" />
      </SimpleForm>
    </Create>
  );
};

export const CategoriesShow = () => {
  return <></>;
};

const PostPanel = ({ record }) => {
  if (record.categories) {
    return (
      <table className="menu-expand-category">
        {record.categories.map((category) => (
          <tr>
            <td className="menu-child-empty">&nbsp;</td>

            <td className="menu-child-category_name">{category.name_tc}</td>
            <td className="menu-child-category_name_en">{category.name_en}</td>
            <td className="menu-child-category_start">
              <MyDateField source="start_time" showTime />
            </td>
            <td className="menu-child-category_end">
              <MyDateField source="end_time" showTime />
            </td>
            <td className="menu-child-category_edit">
              <EditButton basePath="/categories" record={{ id: category.category_id }} />
            </td>
            <td className="menu-child-category">&nbsp;</td>
          </tr>
        ))}
      </table>
    );
  } else {
    return <></>;
  }
};
